import React from "react";
import { StaticGoogleMap } from "react-static-google-map";
import { Gcp } from "../../types/gcp";
import { Resource } from "../../types/resource";
import { Site } from "../../types/site";
import HeavyMachineMarker from "./HeavyMachineMarker";
import SiteRectangle from "./SiteRectangle";
import { estimateZoomLevel } from "../../utils/geoUtils";
import { calcSiteMaxWidth } from "../../utils/siteUtils";

type Props = {
  gcp: Gcp;
  resources: Resource[];
  site: Site;
  width: number;
};

const Map: React.FC<Props> = ({ gcp, resources, site, width }) => {
  // MEMO: scaleは1or2しか指定できない。このため地図の最大サイズは実質1280pxとなる
  const scale = width > 640 ? 2 : 1;
  const mapWidth = Math.floor(width / scale);

  const lat = (site.northExtremity + site.southExtremity) / 2;
  const lon = (site.westExtremity + site.eastExtremity) / 2;

  const siteWidthMeters = calcSiteMaxWidth(site);

  // 14はデフォルト固定値. siteWidthMetersがundefinedの場合は14が使われる
  const zoom = siteWidthMeters !== undefined ? estimateZoomLevel(siteWidthMeters, mapWidth) : 14;

  return (
    <>
      <div className="row">
        <div className="col-12 text-center">
          <StaticGoogleMap
            size={`${mapWidth}x${mapWidth}`}
            scale={scale}
            center={`${lat},${lon}`}
            zoom={zoom}
            apiKey={gcp.apiKey}
          >
            {resources.map((resource) => (
              <HeavyMachineMarker resource={resource} key={`resources-${resource.id}`} />
            ))}
            <SiteRectangle site={site} />
          </StaticGoogleMap>
        </div>
      </div>
    </>
  );
};

export default Map;
